if (!customElements.get('subscription-widget')) {
  customElements.define(
    'subscription-widget',
    class SubscriptionWidget extends HTMLElement {
      constructor() {
        super();

        this.main_product_form =
          this.closest('.product')?.querySelector('.product-form form[action*="/cart/add"]') ||
          document.querySelector('.product__page form[action*="/cart/add"]') ||
          document.querySelector('.product form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add.js"]') ||
          document.querySelector('form[action*="/cart/add"]');

        this.currentVariant = JSON.parse(this.querySelector('#currentVariantData')?.textContent || '{}');
        this.sectionId = this.dataset.sectionId;

        // selling_plan input
        if (this.main_product_form) {
          if (!this.main_product_form.querySelector('input[name="selling_plan"]')) {
            this.sellingPlanFormInput = document.createElement('input');
            this.sellingPlanFormInput.setAttribute('type', 'hidden');
            this.sellingPlanFormInput.setAttribute('name', 'selling_plan');
            this.main_product_form.appendChild(this.sellingPlanFormInput);
          } else {
            this.sellingPlanFormInput = this.main_product_form.querySelector('input[name="selling_plan"]');
          }
          this.sellingPlanFormInput.setAttribute('value', '');
        }

        // update when variant changes
        if (this.main_product_form?.querySelector('input[name="id"]') !== null) {
          this.main_product_form.querySelector('input[name="id"]').addEventListener('change', (event) => {
            this.handleVariantChange(event.target.value);
          });
        } else {
          if (typeof subscribe === 'function') {
            this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              this.handleVariantChange(event.data.variant.id);
            });
          } else {
            document.addEventListener('variant:change', (event) => {
              this.handleVariantChange(event.detail.variant.id);
            });
          }
        }
      }

      connectedCallback() {
        this.variantSelects = document.querySelector('variant-selects');

        // purchase type changes
        this.querySelectorAll('input[name="purchase_type"]').forEach((input) => {
          input.addEventListener('change', this.handleSellingPlanInput.bind(this));
          input.addEventListener('click', this.handleInputClick.bind(this));
          input.addEventListener('touchend', this.handleInputTouch.bind(this));
        });

        // click on wrapper for mobile
        this.querySelectorAll('.subscription-widget__option-wrapper').forEach((wrapper) => {
          wrapper.addEventListener('click', this.handleOptionClick.bind(this));
          wrapper.addEventListener('touchend', this.handleOptionTouch.bind(this));
        });

        // selling plan changes
        const select = this.querySelector('.deployer-select');
        if (select) select.addEventListener('change', this.handleSellingPlanInputChange.bind(this));

        this.updateVariantSelectsSubscriptionState();

        this.applyHideOneTimeOffers();
        requestAnimationFrame(() => this.applyHideOneTimeOffers());
        setTimeout(() => this.applyHideOneTimeOffers(), 200);

        this.setupVariantClickListener();

        // Init prices + percent (important for SSR -> JS consistency)
        this.refreshUIFromCurrentState();
        this.updateGrowthGuaranteeVisibility();
      }

      /* ----------------------------
       * Utilities
       * ---------------------------- */

      readJsonScript(id) {
        const el = this.querySelector(`#${id}`);
        if (!el) return null;
        try {
          return JSON.parse(el.textContent);
        } catch (_) {
          return null;
        }
      }

      getSelectedPlanOption() {
        const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
        if (!select || !select.options.length) return null;
        return select.options[select.selectedIndex];
      }

      // ✅ IMPORTANT:
      // - hide_offers=true : frequencyIndex correspond DIRECTEMENT à l’index du variant dans les arrays (0..n)
      //   (car tes arrays sont [50j,100j,150j] et tes options ont freqIndex=1/2 quand tu hides 0)
      // - hide_offers=false : on reste sur currentVariant (pas besoin d’index array)
      getVariantIndexFromPlanOption(option) {
        const freqIdx = parseInt(option?.dataset?.frequencyIndex, 10);
        return Number.isFinite(freqIdx) ? freqIdx : 0;
      }

      // Sync false = abonnement toujours sur la 1ère variante (ex. 1 huile). Sinon variante index = fréquence index.
      getEffectiveVariantIndexForSubscription(option) {
        if (this.dataset.syncVariantsWithFrequencies === 'false') return 0;
        if (this.dataset.hideOffers !== 'true') return 0;
        return this.getVariantIndexFromPlanOption(option);
      }

      getVariantPriceCentsByIndex(variantIdx) {
        const useArrays = this.dataset.hideOffers === 'true' || this.dataset.syncVariantsWithFrequencies === 'false';
        if (!useArrays) return this.currentVariant?.price;
        const prices = this.readJsonScript('subscription-variant-prices');
        if (!prices || variantIdx < 0 || variantIdx >= prices.length) return this.currentVariant?.price;
        return prices[variantIdx];
      }

      getVariantCompareAtCentsByIndex(variantIdx) {
        const useArrays = this.dataset.hideOffers === 'true' || this.dataset.syncVariantsWithFrequencies === 'false';
        if (!useArrays) return this.currentVariant?.compare_at_price;
        const arr = this.readJsonScript('subscription-variant-compare-at-prices');
        if (!arr || variantIdx < 0 || variantIdx >= arr.length) return this.currentVariant?.compare_at_price;
        return arr[variantIdx];
      }

      // Price of "base" (variant) used for subscription calculations (before adjustment)
      getBaseVariantPriceForSubscription(option) {
        if (!option) return this.currentVariant?.price;

        if (this.dataset.hideOffers === 'true' || this.dataset.syncVariantsWithFrequencies === 'false') {
          const variantIdx = this.getEffectiveVariantIndexForSubscription(option);
          return this.getVariantPriceCentsByIndex(variantIdx);
        }

        return this.currentVariant?.price;
      }

      // Reference price used for "real %" (compare_at if available)
      getReferencePriceCents(basePriceCents, option) {
        const useReal = this.dataset.showRealPercentage === 'true';
        if (!useReal) return basePriceCents;

        // base compare_at (no hide offers)
        let compareAt = this.currentVariant?.compare_at_price;

        // hide_offers ou sync false => compare_at de la variante effective (index 0 si sync false)
        if (option && (this.dataset.hideOffers === 'true' || this.dataset.syncVariantsWithFrequencies === 'false')) {
          const variantIdx = this.getEffectiveVariantIndexForSubscription(option);
          const ca = this.getVariantCompareAtCentsByIndex(variantIdx);
          if (ca != null) compareAt = ca;
        }

        if (compareAt && compareAt > basePriceCents) return compareAt;
        return basePriceCents;
      }

      computeAdjustedPriceCents(basePriceCents, option) {
        if (!option) return basePriceCents;

        const type = option.dataset.ajustmentType;
        const valRaw = option.dataset.ajustmentValue;
        const val = valRaw != null ? parseFloat(valRaw) : 0;

        let adjusted = basePriceCents;

        switch (type) {
          case 'fixed_amount':
            adjusted = basePriceCents - val;
            break;
          case 'percentage':
            adjusted = basePriceCents * (1 - val / 100);
            break;
          case 'price':
            adjusted = val;
            break;
          default:
            adjusted = basePriceCents;
            break;
        }
        return adjusted;
      }

      isSubscriptionSelected() {
        return this.querySelector('.subscription-widget__option--subscription.subscription-widget__option--selected') !== null;
      }

      /* ----------------------------
       * UX helpers
       * ---------------------------- */

      applyHideOneTimeOffers() {
        if (this.dataset.hideOffers !== 'true') return;
        const vs = this.variantSelects || this.closest('.product')?.querySelector('variant-selects') || document.querySelector('variant-selects');
        if (!vs) return;
        const labels = vs.querySelectorAll('.variant-option__label');
        if (labels.length < 2) return;
        labels.forEach((label, i) => {
          if (i === 1 || i === 2) label.classList.add('variant-option__label--hidden-in-one-time');
          else label.classList.remove('variant-option__label--hidden-in-one-time');
        });
      }

      /**
       * Affiche ou masque la 4ème réassurance (growth_guarantee) selon si la variante sélectionnée
       * a le metafield custom.growth_guarantee. Uniquement en mode hide_offers (pas de re-render au changement de variante).
       */
      updateGrowthGuaranteeVisibility() {
        if (this.dataset.hideOffers !== 'true') return;
        const growthGuaranteeFlags = this.readJsonScript('subscription-variant-growth-guarantee');
        if (!Array.isArray(growthGuaranteeFlags)) return;
        const option = this.getSelectedPlanOption();
        const variantIdx = this.getEffectiveVariantIndexForSubscription(option);
        const show = growthGuaranteeFlags[variantIdx] === true;
        const benefitEl = this.querySelector('.subscription-widget__benefit--growth-guarantee');
        if (benefitEl) {
          benefitEl.style.display = show ? '' : 'none';
        }
      }

      handleInputClick(e) {
        const input = e.target;
        if (!input || input.name !== 'purchase_type') return;
        const isSubscriptionInput = input.closest('.subscription-widget__option--subscription');
        if (isSubscriptionInput && input.checked) {
          e.preventDefault();
          this.switchToOneTimePurchase();
          return;
        }
        if (!input.checked) {
          e.preventDefault();
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      handleInputTouch(e) {
        e.preventDefault();
        const input = e.target;
        if (!input || input.name !== 'purchase_type') return;
        const isSubscriptionInput = input.closest('.subscription-widget__option--subscription');
        if (isSubscriptionInput && input.checked) {
          this.switchToOneTimePurchase();
          return;
        }
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      handleOptionClick(e) {
        if (e.target.closest('.deployer-select')) return;
        const option = e.target.closest('.subscription-widget__option');
        if (!option || option.classList.contains('subscription-widget__option--disabled')) return;

        const input = option.querySelector('input[name="purchase_type"]');
        if (!input) return;

        const isSubscriptionOption = option.classList.contains('subscription-widget__option--subscription');
        if (isSubscriptionOption && input.checked) {
          e.preventDefault();
          e.stopPropagation();
          this.switchToOneTimePurchase();
          return;
        }
        if (!input.checked) {
          e.preventDefault();
          e.stopPropagation();
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      handleOptionTouch(e) {
        if (e.target.closest('.deployer-select')) return;
        const option = e.target.closest('.subscription-widget__option');
        if (!option || option.classList.contains('subscription-widget__option--disabled')) return;

        const input = option.querySelector('input[name="purchase_type"]');
        if (!input) return;

        e.preventDefault();
        const isSubscriptionOption = option.classList.contains('subscription-widget__option--subscription');
        if (isSubscriptionOption && input.checked) {
          e.stopPropagation();
          this.switchToOneTimePurchase();
          return;
        }
        if (!input.checked) {
          e.stopPropagation();
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      setupVariantClickListener() {
        if (!this.variantSelects) return;

        this.variantSelects.querySelectorAll('.variant-option__label').forEach((label) => {
          label.style.touchAction = 'manipulation';
          label.style.webkitTapHighlightColor = 'transparent';
        });

        if (this.variantClickHandler) {
          this.variantSelects.removeEventListener('click', this.variantClickHandler);
          this.variantSelects.removeEventListener('touchstart', this.variantTouchHandler);
        }

        this.variantClickHandler = (e) => this.handleVariantInteraction(e);
        this.variantTouchHandler = (e) => this.handleVariantInteraction(e, true);

        this.variantSelects.addEventListener('click', this.variantClickHandler);
        this.variantSelects.addEventListener('touchstart', this.variantTouchHandler, { passive: false });
      }

      handleVariantInteraction(e, isTouch = false) {
        const label = e.target.closest('.variant-option__label');
        if (!label) return;
        if (this.isSyncingVariant) return;

        const isSubscriptionActive = this.variantSelects.classList.contains('subscription-active');
        if (!isSubscriptionActive) return;

        const input = label.previousElementSibling;
        const isAlreadySelected = input && input.checked;

        if (!isAlreadySelected) {
          setTimeout(() => {
            this.switchToOneTimePurchase();
          }, 50);
        } else {
          this.switchToOneTimePurchase();
        }
      }

      switchToOneTimePurchase() {
        const oneTimeOption = this.querySelector('.subscription-widget__option:not(.subscription-widget__option--subscription)');
        const oneTimeInput = oneTimeOption?.querySelector('input[name="purchase_type"]');
        if (oneTimeInput) {
          oneTimeInput.checked = true;
          oneTimeInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // ✅ prix barré “visuel” (toujours)
      getDisplayCrossedOutPriceCents(option) {
        // sync false ou hide_offers : on lit dans les arrays (variante 0 si sync false)
        if (this.dataset.hideOffers === 'true' || this.dataset.syncVariantsWithFrequencies === 'false') {
          const variantIdx = this.getEffectiveVariantIndexForSubscription(option);
          const p = this.getVariantPriceCentsByIndex(variantIdx);
          const ca = this.getVariantCompareAtCentsByIndex(variantIdx);
          return ca && ca > p ? ca : p;
        }
        const p = this.currentVariant?.price;
        const ca = this.currentVariant?.compare_at_price;
        return ca && ca > p ? ca : p;
      }

      updateSubscriptionCrossedOutPrice(option, adjustedPriceCents, basePriceCents) {
        const priceWrap = this.querySelector('.subscription-widget__option--subscription .subscription-widget__option-price');
        if (!priceWrap) return;
      
        const priceValueEl = priceWrap.querySelector('.subscription-widget__option-price-value');
        if (!priceValueEl) return;
      
        // "highest price" à afficher barré = compare_at si dispo et > base, sinon base price
        // (en hide_offers=true => base/compare_at viennent des arrays via option.frequencyIndex)
        let highest = this.getDisplayCrossedOutPriceCents(option); // retourne compare_at si > base sinon base
        if (highest == null) highest = basePriceCents;
      
        const shouldShow = Number.isFinite(highest) && Number.isFinite(adjustedPriceCents) && highest > adjustedPriceCents;
      
        let sEl = priceWrap.querySelector('s');
      
        if (!shouldShow) {
          if (sEl) sEl.remove();
          return;
        }
      
        if (!sEl) {
          sEl = document.createElement('s');
          // on l’insère avant le prix
          priceWrap.insertBefore(sEl, priceValueEl);
        }
      
        sEl.textContent = formatPrice(highest);
      }
      

      /* ----------------------------
       * Variant change / render
       * ---------------------------- */

      handleVariantChange(variant_id) {
        // Sync false = abonnement toujours sur 1ère variante : ne pas toucher au module (pas de re-render)
        if (this.dataset.syncVariantsWithFrequencies === 'false') return;

        if (this.dataset.hideOffers === 'true') {
          this.refreshUIFromCurrentState();
          this.updateGrowthGuaranteeVisibility();
          return;
        }
        this.saveCurrentState();
        this.toggleLoadingMode();
        this.renderSubscriptionWidget(variant_id);
      }

      saveCurrentState() {
        const isSubscription = this.isSubscriptionSelected();
        const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
        this.savedState = {
          isSubscription,
          sellingPlanIndex: select ? select.selectedIndex : 0,
        };
      }

      restoreState() {
        if (!this.savedState) return;
        const { isSubscription, sellingPlanIndex } = this.savedState;

        // Sync false : garder la fréquence affichée (ex. "1 huile"), ne pas la lier à la variante
        if (this.dataset.syncVariantsWithFrequencies === 'false') {
          const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
          if (select && typeof sellingPlanIndex === 'number' && sellingPlanIndex >= 0 && select.options[sellingPlanIndex]) {
            select.selectedIndex = sellingPlanIndex;
          }
        }

        this.syncSellingPlanWithCurrentVariant();

        if (isSubscription) {
          const subscriptionOption = this.querySelector('.subscription-widget__option--subscription');
          const subscriptionInput = subscriptionOption?.querySelector('input[name="purchase_type"]');

          if (subscriptionInput) {
            subscriptionInput.checked = true;
            this.querySelectorAll('.subscription-widget__option').forEach((o) => o.classList.remove('subscription-widget__option--selected'));
            subscriptionOption.classList.add('subscription-widget__option--selected');

            const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
            if (select && this.sellingPlanFormInput) {
              this.sellingPlanFormInput.value = select.options[select.selectedIndex]?.dataset?.value || '';
            }

            if (this.variantSelects) this.variantSelects.classList.add('subscription-active');
          }
        }

        this.savedState = null;
      }

      syncSellingPlanWithCurrentVariant() {
        const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
        if (!select) return;

        // Une variante avec toutes les fréquences : on ne lie pas le select de fréquence à la variante
        if (this.dataset.syncVariantsWithFrequencies === 'false') {
          const opt = select.options[select.selectedIndex];
          const frequencyIndex = opt?.dataset?.frequencyIndex;
          const frequencyItems = this.querySelectorAll('.subscription-widget__frequency-item');
          frequencyItems.forEach((item) => {
            item.classList.toggle('subscription-widget__frequency-item--active', item.dataset.frequencyIndex === frequencyIndex);
          });
          this.updateSubscribePrices({ target: select });
          return;
        }

        const selectedVariantIndex = this.getSelectedVariantIndex();
        if (selectedVariantIndex === -1 || !select.options[selectedVariantIndex]) return;

        select.selectedIndex = selectedVariantIndex;

        const frequencyIndex = select.options[selectedVariantIndex].dataset.frequencyIndex;
        const frequencyItems = this.querySelectorAll('.subscription-widget__frequency-item');
        frequencyItems.forEach((item) => {
          item.classList.toggle('subscription-widget__frequency-item--active', item.dataset.frequencyIndex === frequencyIndex);
        });

        this.updateSubscribePrices({ target: select });
      }

      getSelectedVariantIndex() {
        if (!this.variantSelects) return -1;
        const labels = this.variantSelects.querySelectorAll('.variant-option__label');
        let selectedIndex = -1;

        labels.forEach((label, index) => {
          const input = label.previousElementSibling;
          if (input && input.checked) selectedIndex = index;
        });

        return selectedIndex;
      }

      async renderSubscriptionWidget(variant_id) {
        const productUrl = this.dataset.url;
        const requestedVariantId = variant_id;
        const sectionId = this.dataset.sectionId;

        fetch(`${productUrl}?variant=${requestedVariantId}&section_id=${sectionId}`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const source = doc.getElementById(`subscription-widget__${this.dataset.sectionId}`);
            const destination = this;

            if (source && destination) destination.innerHTML = source.innerHTML;
            destination.connectedCallback();

            this.currentVariant = JSON.parse(this.querySelector('#currentVariantData')?.textContent || '{}');

            this.restoreState();
            this.refreshUIFromCurrentState();

            this.toggleLoadingMode();
          })
          .catch((err) => {
            console.error("Erreur en tentant de rafraichir le widget d'abonnement:", err);
            this.toggleLoadingMode();
          });
      }

      /* ----------------------------
       * Selling plan change
       * ---------------------------- */

      handleSellingPlanInputChange(e) {
        this.updateSubscribePrices(e);
        this.updateFrequencyText(e);
        this.handleSellingPlanInput(e);

        // Sync variant with selling plan index
        this.syncVariantWithSellingPlan(e);

        // 4ème réassurance : visibilité selon metafield growth_guarantee de la variante
        this.updateGrowthGuaranteeVisibility();

        // Update ATC + sticky
        this.updateButtonAndStickyPrices();
      }

      syncVariantWithSellingPlan(e) {
        // Une variante avec toutes les fréquences : ne jamais changer la variante quand on change la fréquence
        if (this.dataset.syncVariantsWithFrequencies === 'false') return;

        if (this.dataset.hideOffers === 'true') {
          this.setFormVariantFromSubscriptionSelect();
          return;
        }

        const selectedOption = e.target.options[e.target.selectedIndex];
        const frequencyIndex = parseInt(selectedOption.dataset.frequencyIndex, 10);
        if (!Number.isFinite(frequencyIndex)) return;

        const variantLabels = this.variantSelects?.querySelectorAll('.variant-option__label');
        if (!variantLabels || variantLabels.length === 0) return;

        const targetVariantLabel = variantLabels[frequencyIndex];
        if (!targetVariantLabel) return;

        const targetInput = targetVariantLabel.previousElementSibling;
        if (!targetInput || targetInput.checked) return;

        this.isSyncingVariant = true;
        targetVariantLabel.click();
        setTimeout(() => {
          this.isSyncingVariant = false;
        }, 100);
      }

      updateFrequencyText(e) {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const frequencyIndex = selectedOption.dataset.frequencyIndex;
        const frequencyItems = this.querySelectorAll('.subscription-widget__frequency-item');
        frequencyItems.forEach((item) => {
          item.classList.toggle('subscription-widget__frequency-item--active', item.dataset.frequencyIndex === frequencyIndex);
        });
      }

      setFormVariantFromSubscriptionSelect() {
        if (!this.main_product_form) return;

        const variantIds = this.readJsonScript('subscription-variant-ids');
        if (!variantIds) return;

        // Sync false = abonnement toujours sur la 1ère variante : on force l’id au panier
        if (this.dataset.syncVariantsWithFrequencies === 'false') {
          const variantInput = this.main_product_form.querySelector('input[name="id"]');
          if (!variantInput) return;
          const firstId = variantIds[0];
          if (!firstId) return;
          if (String(variantInput.value) === String(firstId)) return;
          variantInput.value = firstId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        if (this.dataset.hideOffers !== 'true') return;

        const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
        if (!select || select.options.length === 0) return;

        const opt = select.options[select.selectedIndex];
        const variantIdx = this.getEffectiveVariantIndexForSubscription(opt);
        if (variantIdx < 0 || variantIdx >= variantIds.length) return;

        const variantInput = this.main_product_form.querySelector('input[name="id"]');
        if (!variantInput) return;

        const newId = variantIds[variantIdx];
        if (!newId) return;
        if (String(variantInput.value) === String(newId)) return;

        variantInput.value = newId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      setFormVariantToOneTimeSelection() {
        if (!this.main_product_form) return;
        if (this.dataset.hideOffers !== 'true' && this.dataset.syncVariantsWithFrequencies !== 'false') return;

        const variantIds = this.readJsonScript('subscription-variant-ids');
        if (!variantIds) return;

        let index = this.getSelectedVariantIndex();
        if (index === -1 || index >= variantIds.length) index = 0;

        const variantInput = this.main_product_form.querySelector('input[name="id"]');
        if (!variantInput) return;

        const newId = variantIds[index];
        if (String(variantInput.value) === String(newId)) return;

        variantInput.value = newId;
        // Sync false : ne pas dispatcher change pour éviter un re-render du thème qui remettrait l’abonnement sélectionné
        if (this.dataset.syncVariantsWithFrequencies !== 'false') {
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncVariantToSubscriptionSelect() {
        // Une variante avec toutes les fréquences : ne jamais forcer la variante pour coller à la fréquence
        if (this.dataset.syncVariantsWithFrequencies === 'false') return;

        if (this.dataset.hideOffers === 'true') {
          this.setFormVariantFromSubscriptionSelect();
          return;
        }

        if (!this.variantSelects) return;

        const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
        if (!select || select.options.length === 0) return;

        const opt = select.options[select.selectedIndex];
        const wantIndex = opt ? parseInt(opt.dataset.frequencyIndex, 10) : 1;
        if (!Number.isFinite(wantIndex)) return;

        const labels = this.variantSelects.querySelectorAll('.variant-option__label');
        if (labels[wantIndex]) {
          this.isSyncingVariant = true;
          labels[wantIndex].click();
          setTimeout(() => {
            this.isSyncingVariant = false;
          }, 150);
        }
      }

      /* ----------------------------
       * Price + % updates
       * ---------------------------- */

      updateSubscribePrices(e) {
        const priceContainer = this.querySelector(
          '.subscription-widget__option--subscription .subscription-widget__option-price-value'
        );
        const selectedOption = e.target.options[e.target.selectedIndex];
      
        const basePrice = this.getBaseVariantPriceForSubscription(selectedOption);
        const adjustedPrice = this.computeAdjustedPriceCents(basePrice, selectedOption);
      
        if (priceContainer) priceContainer.innerText = formatPrice(adjustedPrice);
      
        // ✅ Met à jour le prix barré DANS le module abonnement
        this.updateSubscriptionCrossedOutPrice(selectedOption, adjustedPrice, basePrice);
      
        // ✅ % réel si activé
        const referencePrice = this.getReferencePriceCents(basePrice, selectedOption);
        this.updateSubscribeSavingPercentage(adjustedPrice, referencePrice);
      }
      

      updateSubscribeSavingPercentage(finalPriceCents, referencePriceCents) {
        const containers = this.querySelectorAll('.subscription-widget__dynamic-discount');
        if (!containers?.length) return;

        const ref = (referencePriceCents ?? this.currentVariant.price) / 100;
        const fin = finalPriceCents / 100;

        if (!(ref > fin)) {
          containers.forEach((c) => (c.textContent = ''));
          return;
        }

        const saving = ((ref - fin) / ref) * 100;
        const pct = Math.round(saving) + '%';
        containers.forEach((c) => (c.textContent = pct));
      }

      /* ----------------------------
       * Purchase type selection
       * ---------------------------- */

      handleSellingPlanInput(e) {
        // Ignorer le change quand c’est le radio qui se DÉCOCHE (sinon le 2e change remet l’abonnement)
        if (e.target.type === 'radio' && e.target.name === 'purchase_type' && !e.target.checked) return;

        const selectedOption = e.target.closest('.subscription-widget__option');
        if (selectedOption) {
          const selectedInput = selectedOption.querySelector('input[name="purchase_type"]');
          if (selectedInput) {
            selectedInput.checked = true;
            this.querySelectorAll('input[name="purchase_type"]').forEach((inp) => {
              inp.checked = inp === selectedInput;
            });
          }
          this.querySelectorAll('.subscription-widget__option').forEach((o) => o.classList.remove('subscription-widget__option--selected'));
          selectedOption.classList.add('subscription-widget__option--selected');
        }

        if (selectedOption && selectedOption.classList.contains('subscription-widget__option--subscription')) {
          this.updateVariantSelectsSubscriptionState();
          const select = selectedOption.querySelector('.deployer-select');

          const isRadioClick = e.target.tagName === 'INPUT' && e.target.type === 'radio';
          if (isRadioClick && select) {
            if (this.dataset.syncVariantsWithFrequencies === 'false' || this.dataset.hideOffers === 'true') {
              select.selectedIndex = 0;
            } else {
              const selectedVariantIndex = this.getSelectedVariantIndex();
              if (selectedVariantIndex !== -1 && select.options[selectedVariantIndex]) {
                select.selectedIndex = selectedVariantIndex;
              }
            }

            const opt = select.options[select.selectedIndex];
            const frequencyIndex = opt?.dataset?.frequencyIndex;
            const frequencyItems = this.querySelectorAll('.subscription-widget__frequency-item');
            frequencyItems.forEach((item) => {
              item.classList.toggle('subscription-widget__frequency-item--active', item.dataset.frequencyIndex === frequencyIndex);
            });

            this.syncVariantToSubscriptionSelect();
            this.updateSubscribePrices({ target: select });
          }

          if (this.sellingPlanFormInput) {
            this.sellingPlanFormInput.value = select?.options?.[select.selectedIndex]?.dataset?.value || '';
          }

          // hide_offers ou sync false : mettre la variante du formulaire (1ère variante si sync false)
          if (this.dataset.hideOffers === 'true' || this.dataset.syncVariantsWithFrequencies === 'false') {
            this.setFormVariantFromSubscriptionSelect();
          }
        } else {
          const subscriptionOption = this.querySelector('.subscription-widget__option--subscription');
          if (subscriptionOption) {
            const subInput = subscriptionOption.querySelector('input[name="purchase_type"]');
            if (subInput) subInput.checked = false;
            subscriptionOption.classList.remove('subscription-widget__option--selected');
          }
          if (this.sellingPlanFormInput) this.sellingPlanFormInput.value = '';
          this.setFormVariantToOneTimeSelection();
        }

        this.updateVariantSelectsSubscriptionState();
        this.updateButtonAndStickyPrices();
      }

      updateVariantSelectsSubscriptionState() {
        if (!this.variantSelects) return;
        if (this.isSubscriptionSelected()) this.variantSelects.classList.add('subscription-active');
        else this.variantSelects.classList.remove('subscription-active');
      }

      /* ----------------------------
       * ATC + Sticky price updates
       * ---------------------------- */

      getSubscriptionPrice() {
        const option = this.getSelectedPlanOption();
        const basePrice = this.getBaseVariantPriceForSubscription(option);
        return this.computeAdjustedPriceCents(basePrice, option);
      }

      updateButtonAndStickyPrices() {
        const isSub = this.isSubscriptionSelected();

        const priceToDisplay = isSub ? this.getSubscriptionPrice() : this.currentVariant.price;

        // ✅ prix barré ATC (visuel) = compare_at du variant correspondant si dispo
        let crossedOut = this.currentVariant.compare_at_price;
        if (isSub) {
          const opt = this.getSelectedPlanOption();
          crossedOut = this.getDisplayCrossedOutPriceCents(opt);
        }

        const addToCartButton = this.main_product_form?.querySelector('button[name="add"]');
        if (addToCartButton) {
          const priceContainer = addToCartButton.querySelector('.product__price .price');
          if (priceContainer) this.updatePriceElement(priceContainer, priceToDisplay, crossedOut, isSub);
        }

        const stickyButton = document.querySelector('sticky-atc-button');
        if (stickyButton) {
          const stickyPriceContainer = stickyButton.querySelector('.sticky-atc-button__price .price');
          if (stickyPriceContainer) this.updatePriceElement(stickyPriceContainer, priceToDisplay, crossedOut, isSub);
        }
      }

      updatePriceElement(priceContainer, price, compareAtPrice, isSubscription) {
        const regularPriceItem = priceContainer.querySelector('.price__regular .price-item--regular');
        const salePriceItem = priceContainer.querySelector('.price__sale .price-item--sale');
        const saleRegularPriceItem = priceContainer.querySelector('.price__sale .price-item--regular');

        const formattedPrice = formatPrice(price);

        if (regularPriceItem) {
          regularPriceItem.textContent = formattedPrice;
          regularPriceItem.dataset.price = price;
        }
        if (salePriceItem) {
          salePriceItem.textContent = formattedPrice;
          salePriceItem.dataset.price = price;
        }

        // show on-sale only if compareAtPrice > price
        const crossedOutPrice = compareAtPrice && compareAtPrice > price ? compareAtPrice : null;

        if (crossedOutPrice) {
          priceContainer.classList.add('price--on-sale');
          if (saleRegularPriceItem) {
            saleRegularPriceItem.textContent = formatPrice(crossedOutPrice);
            saleRegularPriceItem.dataset.price = crossedOutPrice;
          }
        } else {
          priceContainer.classList.remove('price--on-sale');
        }
      }

      /* ----------------------------
       * Init / refresh
       * ---------------------------- */

      refreshUIFromCurrentState() {
        const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');

        if (select) {
          this.updateSubscribePrices({ target: select });

          if (this.isSubscriptionSelected()) {
            if (this.sellingPlanFormInput) {
              this.sellingPlanFormInput.value = select?.options?.[select.selectedIndex]?.dataset?.value || '';
            }
            if (this.dataset.hideOffers === 'true' || this.dataset.syncVariantsWithFrequencies === 'false') {
              this.setFormVariantFromSubscriptionSelect();
            }
          } else {
            if (this.sellingPlanFormInput) this.sellingPlanFormInput.value = '';
          }
        }

        this.updateGrowthGuaranteeVisibility();
        this.updateButtonAndStickyPrices();
      }

      toggleLoadingMode() {
        this.classList.toggle('subscription-widget--loading');
      }
    }
  );
}